import { render } from "./view-layout.responsive.vue?vue&type=template&id=0ea3f87a&scoped=true"
import script from "./view-layout.responsive.vue?vue&type=script&lang=js"
export * from "./view-layout.responsive.vue?vue&type=script&lang=js"

import "./view-layout.responsive.vue?vue&type=style&index=0&id=0ea3f87a&lang=scss"
import "./view-layout.responsive.vue?vue&type=style&index=1&id=0ea3f87a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea3f87a"]])

export default __exports__